import React, { useEffect, useState } from 'react';
import './counterparties.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import { generateInvoiceSagaAction } from "../../redux/sagaActions";
import { GetCounterpartiesThunk } from "../../redux/thunks/GetCounterpartiesThunk";
import Checkbox from "../../components/Checkbox/Checkbox";
import { setCounterpartiesAction } from "../../redux/rootReducer";

const Counterparties = () => {
    const dispatch = useDispatch();
    const counterparties = useSelector(state => state.counterparties);

    const [exclude, setExclude] = useState([]);

    // Определение текущего номера счёта
    const curInvoice = (index) => {

        if (index === 0) {
            return parseInt(counterparties.invoice.number);
        }
        else {
            // Количество пропусков до текущего элемента
            let gaps = 0;

            exclude.forEach(elem => {

                if (elem < index) {
                    gaps++;
                }
            });

            return parseInt(counterparties.invoice.number) + index - gaps;
        }
    };

    useEffect(() => {
        // Получаем список контрагентов при первой отрисовке
        dispatch(GetCounterpartiesThunk());
    }, []);

    useEffect(() => {
        // Добавляем исключения для уже созданных счетов
        let excludes_idx = [];

        counterparties.counterparties.forEach((elem, index) => {
            if (counterparties.invoice_exclude.includes(elem.id)) {
                excludes_idx.push(index);
            }
        });

        setExclude(excludes_idx);

    }, [counterparties]);

    return (
        <>
            <Header/>
            <div className="page">
                <div className="page__content">
                    <div className="counterparties__fields">
                        <div className="counterparties__field">
                            <div className="input__caption">Номер счёта</div>
                            <input type="text" className="input"
                                   value={ counterparties.invoice.number }
                                   onInput={ event => {
                                       dispatch(setCounterpartiesAction({
                                           ...counterparties,
                                           invoice: {
                                               ...counterparties.invoice,
                                               number: event.target.value
                                           }
                                       }));
                                   } }
                            />
                        </div>
                        <div className="counterparties__field">
                            <div className="input__caption">Дата выставления</div>
                            <input type="date" className="input"
                                   value={ counterparties.invoice.date }
                                   onChange={ event => {
                                       dispatch(setCounterpartiesAction({
                                           ...counterparties,
                                           invoice: {
                                               ...counterparties.invoice,
                                               date: event.target.value
                                           }
                                       }));
                                   } }
                            />
                        </div>
                        <div className="counterparties__field">
                            <div className="input__caption">Период выставления</div>
                            <input type="month" className="input"
                                   value={ counterparties.invoice.period }
                                   onChange={ event => {
                                       dispatch(setCounterpartiesAction({
                                           ...counterparties,
                                           invoice: {
                                               ...counterparties.invoice,
                                               period: event.target.value
                                           }
                                       }));

                                       // Обновляем список контрагентов
                                       dispatch(GetCounterpartiesThunk({ period: event.target.value }));
                                   } }
                            />
                        </div>
                        <div className="counterparties__field counterparties__field--service">
                            <div className="input__caption">Наименование услуги</div>
                            <input type="text" className="input"
                                   value={ counterparties.invoice.subject }
                                   onInput={ event => {
                                       dispatch(setCounterpartiesAction({
                                           ...counterparties,
                                           invoice: {
                                               ...counterparties,
                                               subject: event.target.value
                                           }
                                       }));
                                   } }
                            />
                        </div>
                    </div>
                    <div className="table">
                        <div className="table__row table__row--header table__row--counterparties">
                            <div className="table__cell">Id</div>
                            <div className="table__cell">Название приложения</div>
                            <div className="table__cell">Юридическое название</div>
                            <div className="table__cell">Сумма</div>
                            <div className="table__cell"/>
                            <div className="table__cell" style={{ backgroundColor: 'white', display: 'flex', alignItems: 'center', paddingLeft: '22px' }}>
                                <Checkbox
                                    active={ exclude.length === counterparties.counterparties.length }
                                    caption={ exclude.length !== counterparties.counterparties.length ? 'Выбрать всё' : 'Снять всё' }
                                    handler={ () => {
                                        // Если отмечаем всё
                                        if (exclude.length !== counterparties.counterparties.length) {
                                            setExclude(counterparties.counterparties.map((el, index) => index));
                                        }
                                        else {
                                            setExclude([]);
                                        }
                                    } }
                                />
                            </div>
                            <div className="table__cell"/>
                        </div>
                        {
                            counterparties.counterparties.map((elem, index) => {
                                return (
                                    <div className="table__row table__row--counterparties table__row--hover" key={ elem.id }>
                                        <div className="table__cell">{ elem.id }</div>
                                        <div className="table__cell">{ elem.app_name }</div>
                                        <div className="table__cell">{ elem.legal_name }</div>
                                        <div className="table__cell">
                                            <input type="number" className="input input--cell"
                                                value={ elem.sum }
                                                onInput={ event => {
                                                    // Копируем список контрагентов
                                                    let dataCopy = [...counterparties.counterparties];
                                                    // Меняем значение суммы для текущего контрагента
                                                    dataCopy[index] = {
                                                        ...dataCopy[index],
                                                        sum: event.target.value
                                                    };

                                                    dispatch(setCounterpartiesAction({
                                                        ...counterparties,
                                                        counterparties: dataCopy
                                                    }));
                                                } }
                                            />
                                        </div>
                                        <div className="table__cell table__cell--hover"
                                            onClick={ () => {
                                                dispatch(generateInvoiceSagaAction({
                                                    invoice: curInvoice(index),
                                                    date: counterparties.invoice.date,
                                                    period: counterparties.invoice.period,
                                                    subject: counterparties.invoice.subject,
                                                    counterparty: elem.id,
                                                    sum: elem.sum,
                                                    app_name: elem.app_name,
                                                    type: 'download'
                                                }));
                                            } }
                                        >{ exclude.includes(index) || !counterparties.invoice.number || isNaN(parseInt(counterparties.invoice.number)) ? '' : `Скачать счёт ${ curInvoice(index) }` }</div>
                                        <div className="table__cell">
                                            <div className="invoice__exclude">
                                                <Checkbox
                                                    active={ exclude.includes(index) }
                                                    caption={ 'Исключить' }
                                                    handler={ () => {
                                                        if (exclude.includes(index)) {
                                                            setExclude(exclude.filter(el => el !== index));
                                                        }
                                                        else {
                                                            setExclude([...exclude, index]);
                                                        }
                                                    } }
                                                />
                                            </div>
                                        </div>
                                        <div className="table__cell table__cell--hover"
                                             onClick={ () => {
                                                 dispatch(generateInvoiceSagaAction({
                                                     invoice: curInvoice(index),
                                                     date: counterparties.invoice.date,
                                                     period: counterparties.invoice.period,
                                                     subject: counterparties.invoice.subject,
                                                     counterparty: elem.id,
                                                     sum: elem.sum,
                                                     app_name: elem.app_name,
                                                     type: 'email'
                                                 }));
                                             } }
                                        >Отправить на почту</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Counterparties;